// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2-g8i","additionalInfo":"AgreementModal_additionalInfo__2Q771"};